<template>
  <v-col
    :cols="showListObjectInfoVertically ? 12 : 6"
    :class="'align-self-end ' + (showListObjectInfoVertically ? 'pt-2' : '')"
  >
    <v-container class="px-0 pb-1 pt-2">
      <v-row>
        <v-col
          v-if="showListObjectInfoVertically"
          class="pt-3 grow text-left"
          style="text-align: right; padding: 0 10px 0 14px; position: relative"
        >
          <ObjectPrice
            :object="object"
            :dialog-view="dialogView"
          />
        </v-col>

        <v-col
          v-if="!showListObjectInfoVertically"
          cols="12"
          class="pb-1"
        >
          <div
            v-if="!hidePrice"
            class="text-right pr-1"
            style="overflow: auto"
          >
            <ObjectPrice
              v-if="!emailing"
              :object="object"
            />
          </div>
          <div class="pb-2 pt-2 text-right">
            <v-btn
              :to="objectLink(object)"
              class="csr-btn"
              small
            >
              {{ $t('vaata') }}
            </v-btn>
            <v-btn
              v-if="!homepage && !bookingNow"
              class="csr-btn ml-3"
              small
              @click="selectAndShowBookingForm(object)"
            >
              {{ $t('broneeri_kohe') }}
            </v-btn>
          </div>
        </v-col>
        <v-col
          v-if="showListObjectInfoVertically"
          class="pt-3 shrink mr-1"
        >
          <v-btn
            :to="objectLink(object)"
            class="csr-btn elevation-1"
            small
          >
            {{ $t('vaata') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import ObjectPrice from '@/components/Object/ObjectPrice'
import sharedMethods from '@/methods/sharedMethods'
import sharedComputed from '@/methods/sharedComputed'

export default {
  name: 'ListObjectBottomInfoBar',

  components: {
    ObjectPrice,
  },

  props: {
    object: {
      type: Object,
      default: () => {},
    },
    hidePrice: {
      type: Boolean,
      default: false,
    },
    emailing: {
      type: Boolean,
      default: false,
    },
    bookingNow: {
      type: Boolean,
      default: false,
    },
    dialogView: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...sharedComputed,
  },

  methods: {
    ...sharedMethods,

    selectAndShowBookingForm(object) {
      this.$router.push({ path: this.objectBookingLink(object) })
      window.scrollTo(0, 0)
    },
  },
}
</script>
